import { useState } from 'react';
import CountryPriceManager from './CountryPriceManager';
import UserManager from './UserManager';

type TabType = 'countries' | 'users';

export default function AdminPanel() {
  const [activeTab, setActiveTab] = useState<TabType>('countries');

  return (
    <div className="max-w-7xl mx-auto py-8 space-y-8">
      <h1 className="text-3xl font-bold mb-6">Configuració</h1>
      
      {/* Navegació per pestanyes */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveTab('countries')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'countries'
                ? 'border-black text-black'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Preus per països
          </button>
          
          <button
            onClick={() => setActiveTab('users')}
            className={`
              py-4 px-1 border-b-2 font-medium text-sm
              ${activeTab === 'users'
                ? 'border-black text-black'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
            `}
          >
            Gestió d'usuaris
          </button>
        </nav>
      </div>

      {/* Contingut de les pestanyes */}
      <div className="mt-6">
        {activeTab === 'countries' && <CountryPriceManager />}
        {activeTab === 'users' && <UserManager />}
      </div>
    </div>
  );
}